// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/realtime-project-tracker.png",
    title: "Real-Time Collaborative Project Tracker |  Spring Boot + React  ",
    description:
      "Built a Jira-like project tracker with Spring Boot microservices, webSockets, Redis pub/sub, and JWT-based RBAC to support secure real-time team collaboration; delivered live Kanban updates in under 50ms",
    tech_stack: ["React", "JavaScript","TailwindCSS","Spring Boot","Redis","WebSockets"],
    github_url: "https://github.com/RohanK-coder/Real-Time-Project-Tracker",
    demo_url: "https://youtu.be/Dq23r8Pcyvw?si=EjQ_A6YxYxIcYB3v",
  },
  {
    img: "/healthcare.png",
    title: "Healthcare Appointment System |  Spring Boot + React  ",
    description:
      "Architected a three-portal healthcare appointment system with Spring Security RBAC and calendar-based slot management to streamline scheduling; supported automated reminders and summaries for 500+ scheduled records in under 2 minutes.",
    tech_stack: ["React", "JavaScript","TailwindCSS","Spring Boot","Spring Security","JWT"],
    github_url: "https://github.com/RohanK-coder/Healthcare-Appointment-System",
    demo_url: "https://youtu.be/bQB_qbs24rQ?si=GLxaAeigEX4b98b6",
  },
  {
    img: "/chain.png",
    title: "Chain – built by students for students |  Node.js + React + Express + MySQL ",
    description:
      "Developed Chain, a student-focused messaging and community platform, to help university students find classmates, form study groups, discuss questions, share files, and organize study events",
    tech_stack: ["React", "JavaScript","TailwindCSS"],
    github_url: "https://github.com/RohanK-coder/chain",
    demo_url: "https://youtu.be/o_OyJbvbddM?si=yQACc0kJDZG4fmbT",
  },
  
  {
    img: "/react-code-compiler.png",
    title: "React Online Code Compiler",
    description:
      "Developed a React-based code compiler that supports JavaScript, Java, Python, and C++",
    tech_stack: ["React", "JavaScript","TailwindCSS"],
    github_url: "https://github.com/RohanK-coder/Online-Code-Editor",
    demo_url: "https://onlinecodeeditorrohan.netlify.app/",
  },
  {
    img: "/krypt.png",
    title: "Blockchain based Computer Hardware Procuring System",
    description:
      "A safety application for the Renewable Resources Dept. of BCIT",
    tech_stack: ["React", "Solidity","Blockchain","Smart-Contracts"],
    github_url: "https://github.com/RohanK-coder/Blockchain-Project",
    demo_url: "https://jade-medovik-72fde8.netlify.app/",
  },
  {
    img: "/banking-app.png",
    title: "Banking Application with Loan Request System",
    description:
      "Built a full-stack banking platform using MongoDB, Express.js, React.js, and Node.js, featuring secure JWT-based user authentication and role-based access and also loan request system",
    tech_stack: ["HTML", "CSS", "NodeJs", "MongoDB", "React","Express","AWS"],
    github_url: "https://github.com/RohanK-coder/techdome-bankingApp",
    demo_url: "https://techdome-banking-app.vercel.app/",
  },
  {
    img: "/smart-village.png",
    title: "SmartVillage.GENAI – A System to Solve Rural Challenges",
    description:
      "Built a platform with challenge listings, sector-based filters, project showcases, and partner organization sections and enabled users to post challenges, submit solutions, and track progress",
    tech_stack: ["ReactJs", "NodeJs", "MongoDB","Express","CloudFlare"],
    github_url: "https://github.com/RohanK-coder/SmartVillage.GenAI`",
    demo_url: "https://smartvillage-genai.netlify.app/",
  },
  
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg",
    name: "NextJs",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    name: "Typescript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  
  
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    name: "C",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    name: "Java",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "Bootstrap",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
    name: "Material UI",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    name: "Figma",
  },
  
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
];
